import { detect } from 'detect-browser'

const browser = detect()

if (!Object.prototype.hasOwnProperty.call(document, 'browser_class')) {
	const browser_version = browser.version.split('.')
	const browser_html_class =
		browser.name + '-' + (Array.isArray(browser_version) ? browser_version[0] : browser_version)

	document.browser_class = browser_html_class
	document.querySelector('html').classList.add(browser_html_class)
}

export { browser }
